import { sample } from 'effector';
import { signout } from '@features/common';
import { $config, $filters, FilterToolbarGate } from '../main';
import { getPayloadDeleteFiltersUpdateStorage, getPayloadUpdateStorage } from './helpers';
import {
  $error,
  $savedFilters,
  clearError,
  errorOccured,
  fxGetStorage,
  fxUpdateStorage,
  filterNameForm,
  deleteSavedFilters,
} from './model';

$savedFilters
  .on(fxGetStorage.doneData, (_, data) => (Array.isArray(data) ? data : []))
  .reset([FilterToolbarGate.close, signout]);

/** Запрашиваю сохраненные фильтры */
sample({
  clock: [$config, fxUpdateStorage.done],
  source: $config,
  fn: (config) => ({ storage_key: config!.id }),
  target: fxGetStorage,
});

/** Сохраняю новые фильтры */
sample({
  clock: filterNameForm.submitted,
  source: { filters: $filters, config: $config, savedFilters: $savedFilters },
  fn: ({ filters, config, savedFilters }, formValues) =>
    getPayloadUpdateStorage({
      newFilters: {
        name: formValues.filterName,
        filters,
      },
      config,
      savedFilters,
    }),
  target: fxUpdateStorage,
});

sample({
  clock: deleteSavedFilters,
  source: { config: $config, savedFilters: $savedFilters },
  fn: ({ config, savedFilters }, deleteSavedFilters) =>
    getPayloadDeleteFiltersUpdateStorage({ config, savedFilters, deleteSavedFilters }),
  target: fxUpdateStorage,
});

$error
  .on(errorOccured, (_, data) => {
    const { error } = data;

    if (typeof error.message === 'string') return error;

    return JSON.parse(error.message ?? '{}');
  })
  .reset([FilterToolbarGate.close, signout, clearError]);
